import { makeAutoObservable } from "mobx";
import { createClient, localGet } from "@/core/helpers";
import { ApiClient } from "@/clients/ApiClient";

export class UserStore {
    private client: ApiClient;
    userId = "";
    lastEpisodes: Episode[] = [];
    lastPodcasts: Podcast[] = [];
    episodeIds = "";
    podcastIds = "";

    loadingEpisodeColl = false;

    constructor() {
        makeAutoObservable(this);
        this.client = createClient();

        let existing = sessionStorage.getItem("hp_session_id");
        if (!existing && globalThis.crypto?.randomUUID) {
            try {
                existing = globalThis.crypto.randomUUID();
                sessionStorage.setItem("hp_session_id", existing);
            } catch (e) {
                console.error(e);
            }
        }

        if (!existing) {
            existing = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
            sessionStorage.setItem("hp_session_id", existing);
        }

        this.userId = existing;
        window.clientId = existing;
    }

    async suggest(url: string) {
        if (this.userId.length === 0) return;
        const payload = {
            client: this.userId,
            url,
        };
        await this.client.post("/podcasts/suggest", payload);
    }

    async latestEpisodes() {
        if (this.loadingEpisodeColl) return;

        this.loadingEpisodeColl = true;
        const episodeIds: unknown = await localGet("hp_episode_history");
        if (episodeIds && Array.isArray(episodeIds) && episodeIds.length > 0) {
            const ids = episodeIds.join(",");
            if (this.episodeIds === ids) {
                return;
            }
            const { episodes } = await this.client.get<EpisodesResponse>(
                "/episodes/collection?ids=" + episodeIds.join(",")
            );
            this.lastEpisodes = episodes;
            this.episodeIds = ids;
        }
        this.loadingEpisodeColl = false;
    }

    async latestPodcasts() {
        const podcastIds: unknown = await localGet("hp_pod_history");
        if (podcastIds && Array.isArray(podcastIds) && podcastIds.length > 0) {
            const ids = podcastIds.join(",");
            if (this.podcastIds === ids) {
                return;
            }
            const { podcasts } = await this.client.get<PodcastsResponse>("/podcasts/collection?ids=" + ids);
            this.lastPodcasts = podcasts;
            this.podcastIds = ids;
        }
    }

    async trackUserEvents(action: string, payload: unknown = {}) {
        await this.client.post("/user/action", {
            action,
            payload,
            client: this.userId ?? "",
        });
    }
}
